import notificationService from '../../services/notificationService';
import logger from '../../utils/logger';

const createNotificationSlice = (set, get) => ({
    // Bildirim durumu
    notifications: {
        soundEnabled: true,
        visualEnabled: true,
        lastCustomerCount: 0,
        lastNotificationTime: null,
        notificationCooldown: 3000, // 3 saniye bekleme süresi
        // Davet bildirimleri için yeni state'ler
        lastInviteCount: 0,
        lastInviteNotificationTime: null,
        inviteNotificationCooldown: 2000, // 2 saniye bekleme süresi
    },

    // Bildirim ayarlarını güncelle
    updateNotificationSettings: (settings) => {
        set(state => ({
            notifications: {
                ...state.notifications,
                ...settings
            }
        }));
    },

    // Sesli bildirim durumunu değiştir
    toggleSoundNotifications: () => {
        set(state => ({
            notifications: {
                ...state.notifications,
                soundEnabled: !state.notifications.soundEnabled
            }
        }));
    },

    // Görsel bildirim durumunu değiştir
    toggleVisualNotifications: () => {
        set(state => ({
            notifications: {
                ...state.notifications,
                visualEnabled: !state.notifications.visualEnabled
            }
        }));
    },

    // Müşteri sayısı değişikliğini kontrol et ve bildirim gönder
    checkCustomerCountChange: (newCount, newCustomers = []) => {
        const { notifications } = get();
        const now = Date.now();

        // Cooldown kontrolü
        if (notifications.lastNotificationTime &&
            (now - notifications.lastNotificationTime) < notifications.notificationCooldown) {
            return;
        }

        // Müşteri sayısı arttıysa bildirim gönder
        if (newCount > notifications.lastCustomerCount) {
            const newCustomer = newCustomers.find(customer =>
                !get().waitingCustomers?.some(existing => existing.id === customer.id)
            );

            if (newCustomer) {
                get().showCustomerNotification(newCustomer.name, newCount);

                // Son bildirim zamanını güncelle
                set(state => ({
                    notifications: {
                        ...state.notifications,
                        lastCustomerCount: newCount,
                        lastNotificationTime: now
                    }
                }));
            }
        } else {
            // Müşteri sayısını güncelle (bildirim gönderme)
            set(state => ({
                notifications: {
                    ...state.notifications,
                    lastCustomerCount: newCount
                }
            }));
        }
    },

    // ✅ YENİ: Davet sayısı değişikliğini kontrol et ve bildirim gönder
    checkInviteCountChange: (newCount, newInvites = []) => {
        const { notifications } = get();
        const now = Date.now();

        // Cooldown kontrolü
        if (notifications.lastInviteNotificationTime &&
            (now - notifications.lastInviteNotificationTime) < notifications.inviteNotificationCooldown) {
            return;
        }

        // Davet sayısı arttıysa bildirim gönder
        if (newCount > notifications.lastInviteCount) {
            const newInvite = newInvites.find(invite =>
                !get().invites?.some(existing => existing.token === invite.token)
            );

            if (newInvite) {
                get().showInviteNotification(newInvite.sessionId, newCount);

                // Son bildirim zamanını güncelle
                set(state => ({
                    notifications: {
                        ...state.notifications,
                        lastInviteCount: newCount,
                        lastInviteNotificationTime: now
                    }
                }));
            }
        } else {
            // Davet sayısını güncelle (bildirim gönderme)
            set(state => ({
                notifications: {
                    ...state.notifications,
                    lastInviteCount: newCount
                }
            }));
        }
    },

    // Müşteri bildirimi göster
    showCustomerNotification: async (customerName, customerCount) => {
        const { notifications } = get();

        try {
            if (notifications.soundEnabled || notifications.visualEnabled) {
                /*                 console.log('🔔 Müşteri bildirimi gösteriliyor:', {
                                customerName,
                                    customerCount,
                                    soundEnabled: notifications.soundEnabled,
                                        visualEnabled: notifications.visualEnabled
                            }); */

                if (notifications.soundEnabled && notifications.visualEnabled) {
                    // Hem sesli hem görsel bildirim
                    await notificationService.showCustomerNotification(customerName, customerCount);
                } else if (notifications.soundEnabled) {
                    // Sadece sesli bildirim
                    await notificationService.playSound();
                } else if (notifications.visualEnabled) {
                    // Sadece görsel bildirim
                    await notificationService.showNotification('Yeni Müşteri Bekliyor!', {
                        body: `${customerName} adlı müşteri sıraya eklendi. Toplam ${customerCount} bekleyen müşteri var.`,
                        icon: '/favicon.ico',
                        badge: '/favicon.ico',
                        tag: 'customer-notification',
                        requireInteraction: false,
                        silent: true, // Sesli bildirim kapalıysa sessiz
                        vibrate: [200, 100, 200],
                        onClick: () => {
                            window.focus();
                        }
                    });
                }
            }
        } catch (error) {
            logger.error('❌ Müşteri bildirimi gösterilemedi:', error);
        }
    },

    // ✅ YENİ: Davet bildirimi göster
    showInviteNotification: async (sessionId, inviteCount) => {
        const { notifications } = get();

        try {
            if (notifications.soundEnabled || notifications.visualEnabled) {
                /*                 console.log(' Davet bildirimi gösteriliyor:', {
                                sessionId,
                                    inviteCount,
                                    soundEnabled: notifications.soundEnabled,
                                        visualEnabled: notifications.visualEnabled
                            }); */

                if (notifications.soundEnabled && notifications.visualEnabled) {
                    // Hem sesli hem görsel bildirim
                    await notificationService.showInviteNotification(sessionId, inviteCount);
                } else if (notifications.soundEnabled) {
                    // Sadece sesli bildirim
                    await notificationService.playSound();
                } else if (notifications.visualEnabled) {
                    // Sadece görsel bildirim
                    await notificationService.showNotification('Yeni Davet Linki Oluşturuldu!', {
                        body: `${sessionId} oturumu için yeni davet linki oluşturuldu. Toplam ${inviteCount} aktif davet var.`,
                        icon: '/favicon.ico',
                        badge: '/favicon.ico',
                        tag: 'invite-notification',
                        requireInteraction: false,
                        silent: true, // Sesli bildirim kapalıysa sessiz
                        vibrate: [200, 100, 200],
                        onClick: () => {
                            window.focus();
                            // Admin panelinde davetler sekmesine yönlendir
                            const event = new CustomEvent('navigate-to-invites');
                            window.dispatchEvent(event);
                        }
                    });
                }
            }
        } catch (error) {
            logger.error('❌ Davet bildirimi gösterilemedi:', error);
        }
    },

    // Test bildirimi göster
    showTestNotification: async () => {
        try {
            await notificationService.showCustomerNotification('Test Müşteri', 1);
        } catch (error) {
            logger.error('❌ Test bildirimi gösterilemedi:', error);
        }
    },

    // ✅ YENİ: Test davet bildirimi göster
    showTestInviteNotification: async () => {
        try {
            await notificationService.showInviteNotification('Test Session', 1);
        } catch (error) {
            logger.error('❌ Test davet bildirimi gösterilemedi:', error);
        }
    },

    // ✅ YENİ: Test bağlantı isteği bildirimi göster
    showTestConnectionRequestNotification: async () => {
        try {
            await notificationService.showConnectionRequestNotification('Test Temsilci', 'Test Departman');
        } catch (error) {
            logger.error('❌ Test bağlantı isteği bildirimi gösterilemedi:', error);
        }
    },

    // Bildirim servisini temizle
    cleanupNotifications: () => {
        try {
            notificationService.cleanup();
        } catch (error) {
            logger.error('❌ Bildirim servisi temizlenirken hata:', error);
        }
    },

    // Bildirim izinlerini kontrol et
    checkNotificationPermissions: async () => {
        try {
            const hasPermission = await notificationService.requestPermission();
            return hasPermission;
        } catch (error) {
            logger.error('❌ Bildirim izni kontrol edilemedi:', error);
            return false;
        }
    }
});

export default createNotificationSlice; 
